<script>
   /*********************************************************
   * PredictionsPlot                                        *
   * --------------------                                   *
   * shows plot for regression predictions                  *
   **********************************************************/

   import { min, max, mrange } from 'mdatools/stat';
   import { c, Vector } from 'mdatools/arrays';
   import { Axes, XAxis, YAxis, Box, Segments } from 'svelte-plots-basic/2d';
   import { plsres_get } from '../wasm/pcvpls';

   import PlotSeries from './PlotSeries.svelte';
   import AppLegend from './AppLegend.svelte';


   /*****************************************/
   /* Input parameters                      */
   /*****************************************/
   export let model;                // PCA model object
   export let pvoptions;            // object with PV-options
   export let params;               // JSON with main plot parameters
   export let res;                  // JSON with results
   export let ny = 1;               // number of response to show RMSE for (reserved for future)

   const margins = [0.75, 1.0, 0.1, 0.5];
   const showGrid = true;
   const xLabel = 'Response values (y), reference';
   const yLabel = 'Response values (y), predicted';

   function get_series(id, res, params) {
      const x = new Vector(res.Yref.getcolref(ny));
      const y = new Vector(plsres_get(res, 'Yp', params.ncomp, ny));
      const v = c(x, y);
      return {
         id: id,
         x: x,
         y: y,
         min: min(v),
         max: max(v)
      };
   }

   // get score values
   $: ps = params && res ? Object.keys(res).map(id => get_series(id, res[id], params)) : null;

   // set axis labels
   $: title = params ? 'Predictions (A = ' + params.ncomp + ')' : '';

   // set limits
   $: lim = ps ? mrange([...Object.keys(ps).map(id => ps[id].min), ...Object.keys(ps).map(id => ps[id].max)], 0.1) : [0, 1];
</script>

{#if params && model && res && pvoptions}
<Axes {margins} {xLabel} {yLabel} limX={lim} limY={lim} {title}>

   <Segments xStart={[lim[0]]} yStart={[lim[0]]} xEnd={[lim[1]]} yEnd={[lim[1]]} lineColor="#c0c0c0"/>

   {#each ps as series}
   <PlotSeries values={series} type="p" />
   {/each}

   <AppLegend position="bottomright" />
   <XAxis {showGrid} slot="xaxis" />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>
{/if}